import React, { Component } from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import ConfigurationActions from '../../redux/configurationRedux';
import PartsActions from '../../redux/partsRedux';
import style from '../scenes.scss';
import { isNil } from '../../services/helper';

// Components
import PaintworkBox from '../../components/selectionBoxes/paintworkBox/paintworkBoxComponent';
import SceneNotice from '../../components/notice/sceneNoticeComponent';
import resolvePrice from '../../services/helper/resolvePrice';
import checkMarkedDependency from '../../services/helper/checkMarkedDependency';

class PaintworkScene extends Component {

    componentWillMount() {
        this.listItems();
    }

    listItems = () => {
        const { listPartsRequest, parts, configuration } = this.props;
        if (isNil(parts.paintworks) || configuration.refreshing) {
            listPartsRequest('all', configuration.model.id);
            this.props.setRefreshing(false);
        }
    }

    onSelectItem = (paintwork) => {
        if (!isNil(paintwork)) {
            this.props.updateConfiguration('paintwork', paintwork, this.props.parts);
        }
    }

    resolvePrice = (part, serialParentUid) => resolvePrice(
      part, serialParentUid, this.props.configuration.configurations
    );

    renderPaintworkItems = () => {
        const { parts, configuration } = this.props;

        if (isNil(parts.paintworks)) {
            return null;
        }

        const listItems = parts.paintworks.data.map((paintworkItem) => (
            <PaintworkBox
                key={paintworkItem.uid}
                paintwork={paintworkItem}
                selectedItem={configuration.configurations.paintwork}
                onSelectItem={(item) => this.onSelectItem(item)}
                markedDependencies={configuration.markedDependencies}
                resolvePrice={this.resolvePrice}
            />
        ));

        return (
            <div className={style.form_container_4}>
                {listItems}
            </div>
        );

    }

    render() {
        const { parts, configuration } = this.props;

        if (this.props.fetching === null || this.props.fetching === true) {
            return (
                <h2>{t`LADE`}</h2>
            );
        }
        let hasMarkedDependency = false;
        hasMarkedDependency = checkMarkedDependency(
            parts.paintworks.data,
            configuration.markedDependencies
        );
        return (
            <div className={style.scene}>
                <div className={style.title}>
                    <h2>{t`Lackierung wählen`}</h2>
                </div>
                <form>
                    {
                        hasMarkedDependency ?
                            <SceneNotice content={t`Sie haben nun die Möglichkeit Ihre Konfiguration zu ändern. Eine Änderung kann ggf. Auswirkungen auf die bestehende Konfiguration haben. Bitte prüfen Sie die folgenden Einstellungen!`} />
                            : null
                    }
                    {this.renderPaintworkItems()}
                </form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    caravans: state.caravans.caravans,
    parts: state.parts.parts,
    fetching: state.parts.fetching,
    configuration: state.configuration,
});

const mapDispatchToProps = dispatch => ({
    // eslint-disable-next-line max-len
    updateConfiguration: (category, value, parts) =>
        dispatch(ConfigurationActions.updateConfiguration(category, value, parts)),
    listPartsRequest: (category, identifier) =>
        dispatch(PartsActions.listPartsRequest(category, identifier)),
    setRefreshing: (refresh) =>
        dispatch(ConfigurationActions.setRefreshing(refresh)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaintworkScene);

